import React, { useState, useEffect } from "react"

const defaultState = {
  scrollDir: "scrolling up",
}

const ScrollContext = React.createContext(defaultState)

const ScrollProvider = ({ children }) => {
  const [scrollDir, setScrollDir] = useState("scrolling up");

  useEffect(() => {
    const threshold = 0;
    let lastScrollY = window.pageYOffset;
    let ticking = false;

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;

      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollDir]);

  return (
    <ScrollContext.Provider
      value={{
        scrollDir
      }}
    >
      {children}
    </ScrollContext.Provider>
  );
}

export default ScrollContext

export { ScrollProvider }